import React from 'react';
import "animate.css/animate.min.css";
import ScrollAnimation from 'react-animate-on-scroll';

class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isNavOpen: false
    };
  }

  render() {
    return (
      <section id='contact' className='contact-section-6'>
        <div className="container">
          <div className="row mb-5">
            <div className="col-md-8 col-xl-6 text-center mx-auto">
              <ScrollAnimation animateIn="animate__fadeIn" animateOnce={true} delay={100}>
                <h2 className="font-weight-bold">Contacto</h2>
                <p>Contactanos para obtener información.</p>
              </ScrollAnimation>
            </div>
          </div>
          <div className="row d-flex justify-content-center">
            <div className="col-md-6 col-xl-4">
              <div className="d-flex flex-column justify-content-center align-items-start h-100">
                <ScrollAnimation animateIn="animate__fadeIn" animateOnce={true} delay={150}>
                  <div className="d-flex align-items-center p-3">
                    <i className="fa fa-phone"></i>
                    <div className="px-2">
                      <h6 className="font-weight-bold mb-0">Teléfono</h6>
                      <p className="mb-0">+123456789</p>
                    </div>
                  </div>
                </ScrollAnimation>
                <ScrollAnimation animateIn="animate__fadeIn" animateOnce={true} delay={200}>
                  <div className="d-flex align-items-center p-3">
                    <i className="fa fa-phone"></i>
                    <div className="px-2">
                      <h6 className="font-weight-bold mb-0">Correo</h6>
                      <p className="mb-0">info@example.com</p>
                    </div>
                  </div>
                </ScrollAnimation>
                <ScrollAnimation animateIn="animate__fadeIn" animateOnce={true} delay={250}>
                  <div className="d-flex align-items-center p-3">
                    <i className="fa fa-phone"></i>
                    <div className="px-2">
                      <h6 className="font-weight-bold mb-0">Calle</h6>
                      <p className="mb-0">calle 123</p>
                    </div>
                  </div>
                </ScrollAnimation>
              </div>
            </div>
            <div className="col-md-6 col-xl-4">
              <ScrollAnimation animateIn="animate__fadeIn" animateOnce={true} delay={300}>
                <form className="p-3 p-xl-4" method="post">
                  <div className="mb-3"><input type="text" className="form-control" id="name-1" name="name" placeholder="Nombre" /></div>
                  <div className="mb-3"><input type="email" className="form-control" id="email-1" name="email" placeholder="Correo" /></div>
                  <div className="mb-3"><textarea className="form-control" id="message-1" name="message" rows="6" placeholder="Mensaje"></textarea></div>
                  <div><button className="btn d-block w-100" type="submit">Enviar</button></div>
                </form>
              </ScrollAnimation>

            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Contact;
